// consider using library (https://www.npmjs.com/package/pluralize)
//
export const pluralize = (word: string, count: number, suffix = "s") =>
  `${count} ${word}${count !== 1 ? suffix : ""}`;
